import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ─── Service Worker (PWA Offline) ────────────────────────────────────────────
// Registrar el SW para que el ERP funcione sin internet.
// Solo se activa en producción (npm run build).
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[PWA] ERP instalado y listo para uso offline.');
  },
  onUpdate: (registration) => {
    // Hay una nueva versión del ERP disponible
    console.log('[PWA] Nueva versión disponible. Recarga para actualizar.');
    // Aquí podríamos mostrar un toast al usuario: "Nueva versión disponible"
  },
  onOfflineReady: () => {
    console.log('[PWA] Modo offline activo — sin conexión a internet.');
  }
});

reportWebVitals();

